import { render } from "./ZoneWidgets.vue?vue&type=template&id=83538ed6&scoped=true"
import script from "./ZoneWidgets.vue?vue&type=script&lang=js"
export * from "./ZoneWidgets.vue?vue&type=script&lang=js"

import "./ZoneWidgets.vue?vue&type=style&index=0&id=83538ed6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-83538ed6"

export default script